export const commonThemeComponents = {
  togglebutton: {
    content: {
      sm: {
        padding: '0.25rem 0.5rem',
      },
    },
  },
  button: {
    root: {
      label: {
        fontWeight: '600',
      },
    },
    colorScheme: {
      light: {
        root: {
          contrast: {
            background: '{surface.700}',
            borderColor: '{surface.700}',
            hoverBackground: '{surface.600}',
            hoverBorderColor: '{surface.600}',
            activeBorderColor: '{surface.800}',
          },
        },
      },
    },
  },
  floatlabel: {
    in: {
      input: {
        paddingTop: '1rem',
      },
      active: {
        top: '0.5rem',
      },
    },
  },
};

export const commonThemeSemanticFormField = {
  paddingX: '0.75rem',
  paddingY: '0.5rem',
  sm: {
    fontSize: '0.875rem',
    paddingX: '0.625rem',
    paddingY: '0.375rem',
  },
  lg: {
    fontSize: '1.125rem',
    paddingX: '0.875rem',
    paddingY: '0.625rem',
  },
  borderRadius: '{border.radius.md}',
  focusRing: {
    width: '0',
    style: 'none',
    color: 'transparent',
    offset: '0',
    shadow: 'none',
  },
  transitionDuration: '{transition.duration}',
};

export const commonThemeSemanticOverlay = {
  select: {
    borderRadius: '{border.radius.md}',
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  },
  popover: {
    borderRadius: '{border.radius.md}',
    padding: '.75rem',
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  },
  modal: {
    borderRadius: '{border.radius.xl}',
    padding: '1rem',
    shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
  },
  navigation: {
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  },
};

export const commonThemeLightFormField = {
  background: '{surface.0}',
  disabledBackground: '{surface.100}',
  filledBackground: '{surface.50}',
  filledHoverBackground: '{surface.50}',
  filledFocusBackground: '{surface.50}',
  borderColor: '#ced4da',
  hoverBorderColor: '{surface.500}',
  focusBorderColor: '{primary.700}',
  invalidBorderColor: '{red.400}',
  color: '{surface.700}',
  disabledColor: '{surface.500}',
  placeholderColor: '{surface.500}',
  invalidPlaceholderColor: '{red.600}',
  floatLabelColor: '{surface.500}',
  floatLabelFocusColor: '{primary.600}',
  floatLabelActiveColor: '{surface.500}',
  floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
  iconColor: '{surface.400}',
  shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)',
};

export const commonThemeLightText = {
  color: '{surface.800}',
  hoverColor: '{surface.800}',
  mutedColor: '{surface.500}',
  hoverMutedColor: '{surface.600}',
};
